module.exports = {
	"shared.crew.original-music-composer": "Compositor de música original",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publicista",
	"share-overlay.share": "Compartir este video",
	"shared.crew.associate-producer": "Productor asociado",
	"shared.crew.assistant-editor": "Asistente del editor",
	"overlay.buy-from": "Comprar a precio desde {price}",
	"shared.crew.agent": "Agente",
	"shared.crew.additional-photography": "Fotografía adicional",
	"shared.crew.sound-editor": "Editor de sonido",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Estlista",
	"shared.crew.makeup-effects": "Efectos de maquillaje",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Asistente de producción",
	"shared.crew.executive-producer": "Productor ejecutivo",
	"shared.crew.costumer": "Vestuarista",
	"info-overlay.cast": "Elenco",
	"shared.crew.stunt-coordinator": "Coordinador de dobles",
	"shared.crew.academic-advisor": "Tutor académico",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "El mejor chico",
	"actions.purchased": "Este video es de tu propiedad",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Decorador del set",
	"shared.crew.adaptation": "Adaptación",
	"shared.crew.school-administrator": "Administrador de escuela",
	"shared.crew.cable-person": "Personal de cable",
	"shared.crew.digital-effects": "Efectos digitales",
	"actions.rent": "Alquila por {price}",
	"info-overlay.created-by": "Por {author}",
	"social-share.twitter": "No te pierdas \"{title}\" en {siteUrl}",
	"shared.crew.production-designer": "Diseñador de producción",
	"info-overlay.crew": "Equipo",
	"shared.crew.producer": "Productor",
	"shared.crew.2nd-unit-dir-of-photography": "Director de fotografía- 2da unidad",
	"shared.crew.special-effects": "Efectos especiales",
	"actions.rented": "Alquilado hasta el {date}",
	"shared.crew.boom-operator": "Operador de micrófonos",
	"shared.crew.story": "Historia",
	"shared.crew.script-supervisor": "Supervisor de guión",
	"shared.crew.director": "Director",
	"shared.crew.choreographer": "Coreógrafo",
	"shared.crew.production-manager": "Administrador de producción",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Protagonista",
	"shared.crew.location-manager": "Director de exteriores",
	"shared.crew.costume-designer": "Diseñador de vestuario",
	"fullscreen.exit": "Salir de pantalla completa",
	"shared.crew.technical-advisor": "Tutor técnico",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Grip adicional",
	"actions.buy": "Precio de compra {price}",
	"shared.crew.assistant-camera": "Asistente de cámera",
	"shared.crew.writer": "Escritor",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Colaborador del director",
	"fullscreen.enter": "Pantalla completa",
	"shared.crew.animal-trainer": "Entrenador de animales",
	"shared.crew.assistant-art-director": "Asistente de dirección de arte",
	"shared.crew.key-grip": "Key Grip",
	"social-button.copy": "Copiar",
	"shared.crew.makeup-artist": "Maquillador",
	"overlay.source-error": "El video no puede ser reproducido",
	"social-button.link": "Enlace",
	"actions.buy-from": "Comprar a precio desde {price}",
	"shared.crew.art-director": "Director de arte",
	"shared.crew.production-coordinator": "Coordinador de producción",
	"shared.crew.co-director": "Co-Director",
	"shared.crew.co-producer": "Co-Productor",
	"shared.crew.video-operator": "Operador de video",
	"shared.crew.camera-operator": "Operador de cámara",
	"shared.crew.co-writer": "Co-Escritor",
	"shared.crew.set-designer": "Diseñador del set",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Utilería",
	"shared.crew.cinematographer-dp": "Cinematógrafo/DP",
	"shared.crew.grip": "Controles",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Mezclador de sonido",
	"quality.label": "Calidad",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Capataz",
	"shared.crew.assistant-director": "Asistente del director",
	"actions.subscribe": "Suscribirse {price}/mes",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animador",
	"shared.crew.dolly-grip": "Operador de dolly",
	"shared.crew.manager": "Gerente",
	"shared.crew.2nd-assistant-director": "2do asistente del director",
	"shared.crew.author-of-adapted-material": "Autor del material adaptado"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_es.json
// module id = 2786
// module chunks = 66